export default __webpack_public_path__ + "static/media/115-lowfi-nyc.b4ac6d29.jpeg";